<template>
    <div v-if="reservation && metadata.has_door_locks && metadata.permissions.door_locks_view">
        <grid
            ref="grid"
            class="guest-invoices-grid pt-3"
            overlayNoRowsTemplate="No property has door locks enabled"
            :columnDefs="columnDefs"
            :rowData="reservation.door_codes"
            :headerHeight="45"
            :isAutoWidth="true"
            :isAutoHeight="true"
            :isSearch="false"
            :with-space="false"
        >
        </grid>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Grid from '../../../../generic/grid/grid.vue';
import { isMediumScreen } from '../../../../../utils/screens';
import ActionCellRenderer from './action-cell-renderer.vue';

export default {
    name: 'GuestInvoicesDoorLocksTab',
    components: { Grid, actionCellRenderer: ActionCellRenderer },
    computed: {
        ...mapGetters('guest', ['metadata', 'reservation']),
        columnDefs() {
            return [
                {
                    field: 'rental_property',
                    pinned: 'left',
                    minWidth: 175,
                    width: isMediumScreen() ? undefined : 175,
                    autoWidthExclude: this.isMobile,
                    headerName: 'Rental Property',
                },
                {
                    field: 'from',
                    type: 'dateTimeColumn',
                    headerName: 'From',
                    minWidth: 250,
                },
                {
                    field: 'to',
                    type: 'dateTimeColumn',
                    headerName: 'To',
                    minWidth: 250,
                },
                {
                    field: 'code',
                    headerName: 'Code',
                    autoWidthExclude: true,
                },
                {
                    field: '',
                    headerName: '',
                    editable: false,
                    sortable: false,
                    minWidth: 54,
                    maxWidth: 54,
                    cellRendererParams: {
                        refreshReservation: this.refreshReservation,
                    },
                    cellStyle: { paddingRight: 0, paddingLeft: 0 },
                    cellRenderer: 'actionCellRenderer',
                },
            ];
        },
        isMobile() {
            const md = 768;
            return window.innerWidth < md || window.innerHeight < md;
        },
    },
    methods: {
        refreshReservation(callback) {
            this.$emit('refreshReservations', callback);
        },
    },
};
</script>

<style lang="scss" scoped>
@import '../../guest-invoices-grid.scss';
</style>
